/*eslint-disable */

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Animated } from "react-animated-css";
import { Button, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import { Switch } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Card, CardBody, CardHeader } from "../../../_metronic/_partials/controls/Card";
import * as Api from "../../General/api";
import * as Common from "../../General/common";
import AddPhysicianmodal from './addphysician';
import NewBrightreePhysician from './newbrightreephysician';
import AddEditPhysician from './newPhysician';

export function PhysicianList() {
    const { user } = useSelector((state) => state.auth);
    //#region  add person
    const [showModalAddPhysician, setShowAddPhysician] = useState(false);
    const [syncPhysicianData, setSyncPhysicianData] = useState({ npi: null, firstName: null, lastName: null });
    const [isSyncMode, setIsSyncMode] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingPhysician, setEditingPhysician] = useState(null);


    const handleCloseAdd = () => {
        setShowAddPhysician(false);
        setSyncPhysicianData({ npi: null, firstName: null, lastName: null });
        setIsSyncMode(false);
        // Refresh the physician list when modal closes
        GetPhysicianList();
    };
    
    const handleShowAddPhysician = () => {
        setSyncPhysicianData({ npi: null, firstName: null, lastName: null });
        setIsSyncMode(false);
        setShowAddPhysician(true);
    };

    const handleSavePhysician = (result) => {
        // Refresh the physician list after adding
        GetPhysicianList();
        setShowAddPhysician(false);
        setSyncPhysicianData({ npi: null, firstName: null, lastName: null });
    };

    // Removed handleShowAddBrightreePhysician - not currently used


    //#endregion

    //#region physician list
    const [physician, setPhysician] = useState(null);
    const [physicianListUI, setPhysicianListUI] = useState([]);
    const [selectedPhysicians, setSelectedPhysicians] = useState([]);
    const [physicianListData, setPhysicianListData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [showDuplicateModal, setShowDuplicateModal] = useState(false);
    const [duplicatePhysician, setDuplicatePhysician] = useState(null);
    const [selectedReplacementPhysician, setSelectedReplacementPhysician] = useState(null);
    const [replacementFilter, setReplacementFilter] = useState('');
    //#endregion

    //#region sorting functions
    const sortData = (data, config) => {
        if (!config.key) return data;
        
        const sorted = [...data].sort((a, b) => {
            let aValue, bValue;
            
            if (config.key === 'name') {
                aValue = (Common.replaceNullWithString(a.lastName) + " " + Common.replaceNullWithString(a.firstName)).toLowerCase();
                bValue = (Common.replaceNullWithString(b.lastName) + " " + Common.replaceNullWithString(b.firstName)).toLowerCase();
            } else if (config.key === 'npi') {
                aValue = Common.replaceNullWithString(a.npi) || '';
                bValue = Common.replaceNullWithString(b.npi) || '';
            } else {
                return 0;
            }
            
            if (aValue < bValue) {
                return config.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return config.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
        
        return sorted;
    }

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    }
    //#endregion

    useEffect(() => {
        GetPhysicianList();
    }, []);

    // Memoize sorted data to avoid unnecessary recalculations
    const sortedPhysicianData = useMemo(() => {
        if (physicianListData.length === 0) return [];
        return sortData(physicianListData, sortConfig);
    }, [physicianListData, sortConfig]);

    // Memoize selected physician IDs set for faster lookups
    const selectedPhysicianIds = useMemo(() => {
        return new Set(selectedPhysicians.map(p => p.physicianId));
    }, [selectedPhysicians]);

    // Recreate rows when sorted data or selections change
    useEffect(() => {
        if (sortedPhysicianData.length > 0) {
            setPhysicianList(sortedPhysicianData);
        } else if (sortedPhysicianData.length === 0 && physicianListData.length === 0) {
            setPhysicianListUI([]);
        }
    }, [sortedPhysicianData, selectedPhysicianIds]);

    // Initialize / destroy DataTable after the table rows are rendered.
    // Important: keep all DataTable lifecycle in ONE place to avoid DOM race conditions with React.
    useEffect(() => {
        if (!window.$ || !window.$.fn || !window.$.fn.dataTable) return;

        const $table = window.$("#physicianList");
        if ($table.length === 0) return;

        const destroyIfExists = () => {
            try {
                if (window.$.fn.dataTable.isDataTable("#physicianList")) {
                    // Use destroy(true) to fully remove DataTables-added DOM wrappers
                    $table.DataTable().destroy(true);
                }
            } catch (e) {
                // swallow to avoid breaking render; the goal is to prevent DOM exceptions
                // eslint-disable-next-line no-console
                console.warn("Failed to destroy DataTable safely:", e);
            }
        };

        // Always destroy when loading or when we have no rows
        if (isLoading || physicianListUI.length === 0) {
            destroyIfExists();
            return;
        }

        // Use a slightly longer timeout to ensure React committed DOM updates
        const timer = setTimeout(() => {
            destroyIfExists();
            try {
                // Initialize DataTable with explicit pagination settings
                const $table = window.$("#physicianList");
                if ($table.length > 0 && $table.find("tbody tr").length > 0) {
                    const rowCount = $table.find("tbody tr").length;
                    console.log("Initializing DataTable with", rowCount, "rows");
                    
                    $table.DataTable({
                        destroy: true, // Allow re-initialization
                        "order": [],
                        responsive: true,
                        paging: true,
                        pageLength: 25,
                        lengthMenu: [
                            [25, 50, 100, -1],
                            [25, 50, 100, "All"],
                        ],
                        dom: "<'row'<'col-sm-12 col-md-6'l><'col-sm-12 col-md-6'f>>" +
                             "<'row'<'col-sm-12'tr>>" +
                             "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
                    });
                    
                    // Verify DataTable was initialized
                    if (window.$.fn.dataTable.isDataTable("#physicianList")) {
                        const dt = $table.DataTable();
                        console.log("DataTable initialized. Page length:", dt.page.len(), "Total rows:", dt.rows().count());
                    } else {
                        console.warn("DataTable failed to initialize");
                    }
                }
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to initialize DataTable safely:", e);
            }
        }, 250);

        // Cleanup: destroy DataTable when effect re-runs/unmounts
        return () => {
            clearTimeout(timer);
            destroyIfExists();
        };
    }, [isLoading, physicianListUI]);

    
    


    //#region loop to  print the physician firm list

    const GetPhysicianList = () => {
        setIsLoading(true);
        
        Api.getRequest(Api.URI_GetAllPhysician).then((res) => {

            if (res.data.statusCode == 200) {
                if (res.data.result != null) {
                    if (res.data.result.length > 0) {
                        // Log to check if brightreeId is in response
                        if (res.data.result.length > 0) {
                            console.log("Sample physician object from API:", res.data.result[0]);
                            console.log("brightreeId in response:", res.data.result[0]?.brightreeId);
                        }
                        setPhysicianListData(res.data.result);
                    } else {
                        setPhysicianListData([]);
                        setPhysicianListUI([]);
                    }
                } else {
                    setPhysicianListData([]);
                    setPhysicianListUI([]);
                }
            } else {
                setPhysicianListData([]);
                setPhysicianListUI([]);
            }

            setIsLoading(false);
        }).catch((ex) => {
            setPhysicianListData([]);
            setPhysicianListUI([]);
            setIsLoading(false);
        });
    }

    // Memoized handler for checkbox changes
    const handleCheckboxChange = useCallback((physician, isChecked) => {
        if (isChecked) {
            setSelectedPhysicians(prev => [...prev, physician]);
        } else {
            setSelectedPhysicians(prev => prev.filter(p => p.physicianId !== physician.physicianId));
        }
    }, []);

    const setPhysicianList = (list) => {
        let rows = [];
        try {
            for (var i = 0; i < list.length; i++) {
                const obj = list[i];
                const isSelected = selectedPhysicianIds.has(obj.physicianId);
                rows.push(<tr key={obj.physicianId || i.toString()}>
                    <td>
                        <input 
                            type="checkbox" 
                            value={obj.physicianId}
                            checked={isSelected}
                            onChange={(e) => handleCheckboxChange(obj, e.target.checked)}
                        />
                    </td>
                    <td>{Common.replaceNullWithString(obj.lastName) + " " + Common.replaceNullWithString(obj.firstName)}</td>
                    <td>{Common.replaceNullWithString(obj.title) ? obj.title : "N/A"}</td>
                    <td>{Common.replaceNullWithString(obj.address.phone1) != '' ? obj.address.phone1 : 'N/A'}</td>
                    <td>{Common.replaceNullWithString(obj.address.email) != '' ? obj.address.email : 'N/A'}</td>
                    <td>{Common.replaceNullWithString(obj.npi) != '' ? obj.npi : 'N/A'} </td>
                    <td align="center">
                        <Switch
                            checked={obj.active !== false}
                            onChange={(e) => HandleActiveStatusToggle(obj, e.target.checked)}
                            color="primary"
                            size="small"
                            inputProps={{ 'aria-label': 'active status toggle' }}
                        />
                    </td>
                    <td align="center">
                        <div className="text-center">

                            <DropdownButton
                                drop={"down"}
                                size="xs"
                                variant="primary"
                                title={'Actions'}
                                id={`dropdown-button-drop-actions`}
                                key={'down'}>

                                <Dropdown.Item eventKey={"1" + i.toString()} onClick={() => HandleEditPhysician(obj)}>Edit</Dropdown.Item>
                                <Dropdown.Item eventKey={"5" + i.toString()} onClick={() => HandleUnlinkPhysician(obj.physicianId)}>Unlink Physician</Dropdown.Item>
                                <Dropdown.Item eventKey={"4" + i.toString()} onClick={() => HandleSetAsDuplicate(obj)}>Set as Duplicate</Dropdown.Item>
                                <Dropdown.Item eventKey={"3" + i.toString()} onClick={() => HandleSyncWithBrightree(obj)}>Sync With Brightree</Dropdown.Item>
                                <Dropdown.Item eventKey={"2" + i.toString()} onClick={() => ConfirmDeletePhysician(obj)}>Delete</Dropdown.Item>
                            </DropdownButton>
                        </div>
                    </td>
                </tr>);
            }
            setPhysicianListUI(rows);
        } catch (error) {
        }
    }

    //#endregion

    //#region Edit Physician

    const HandleEditPhysician = (physicianObj) => {
        setEditingPhysician(physicianObj);
        setShowEditModal(true);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setEditingPhysician(null);
        // Refresh the physician list when modal closes
        GetPhysicianList();
    };

    //#endregion

    //#region Update Physician Active Status

    const HandleActiveStatusToggle = (physicianObj, newActiveStatus) => {
        const physicianId = physicianObj.physicianId;
        const apiEndpoint = newActiveStatus ? Api.URI_ActivePhysician : Api.URI_DeactivePhysician;
        const actionText = newActiveStatus ? 'activate' : 'deactivate';

        Api.postRequest(apiEndpoint + "?physicianID=" + physicianId).then((res) => {
            if (res.data.statusCode == 200 || res.data.success) {
                // Update the local state to reflect the change immediately
                setPhysicianListData(prevData => 
                    prevData.map(physician => 
                        physician.physicianId === physicianId 
                            ? { ...physician, active: newActiveStatus }
                            : physician
                    )
                );
                Common.showSuccessAlertAutoClose(
                    `Physician ${actionText}d successfully`, 
                    "success", 
                    "Success!", 
                    3000
                );
            } else {
                Common.showSuccessAlert(res.data.message || `Failed to ${actionText} physician`, "warning", "Failed!", 3000);
            }
        }).catch((ex) => {
            Common.showSuccessAlertAutoClose("Some error occurred while processing your request", "warning", "Failed!", 3000);
        });
    }

    //#endregion

    //#region Unlink Physician

    const HandleUnlinkPhysician = (physicianId) => {
        const confirmMessage = "Are you sure you want to unlink this physician?";
        Common.showConfirmation(
            confirmMessage,
            "Unlink Physician",
            () => {
                Api.getRequest(Api.URI_UnlinkPhysician + "/" + physicianId).then((res) => {
                    if (res.data.statusCode == 200 || res.data.success) {
                        const result = res.data.result;
                        if (result === true || result === "true") {
                            Common.showSuccessAlertAutoClose("Physician unlinked successfully", "success", "Success!", 3000);
                            GetPhysicianList();
                        } else {
                            Common.showSuccessAlert("Failed to unlink physician", "warning", "Failed!", 3000);
                        }
                    } else {
                        Common.showSuccessAlert(res.data.message || "Failed to unlink physician", "warning", "Failed!", 3000);
                    }
                }).catch((ex) => {
                    Common.showSuccessAlertAutoClose("Some error occurred while processing your request", "warning", "Failed!", 3000);
                });
            },
            null,
            null
        );
    }

    //#endregion

    //#region Delete Physician 

    const ConfirmDeletePhysician = (physicianObj) => {

        Common.showConfirmation("Are you sure! You want to delete this physician.", "Delete Physician", DeletePhysician, null, physicianObj)

    }

    const DeletePhysician = (physicianObj) => {
        Api.postRequest(Api.URI_DeletePhysician, physicianObj).then((res) => {
            
            if (res.data.statusCode == 200 || res.data.success) {
                if (res.data.result != null) {
                    Common.showSuccessAlertAutoClose("Physician deleted successfully", "success", "Success!", 3000);
                    GetPhysicianList();
                } 
                else {
                    Common.showSuccessAlert(res.data.message || "Failed to delete physician", "warning", "Failed!", 3000);
                }
            }
            else {
                Common.showSuccessAlert(res.data.message || "Failed to delete physician", "warning", "Failed!", 3000);
            }
        }).catch((ex) => {
            Common.showSuccessAlertAutoClose("some error occured while processing your request", "warning", "Failed!", 3000);
        });
    }

    //#endregion

    //#region Sync Physician 

    const HandleSyncWithBrightree = (physicianObj) => {
        // Prefer NPI over name if available
        const npi = Common.replaceNullWithString(physicianObj.npi);
        const firstName = Common.replaceNullWithString(physicianObj.firstName);
        const lastName = Common.replaceNullWithString(physicianObj.lastName);
        
        setSyncPhysicianData({
            npi: npi && npi.length === 10 ? npi : null,
            firstName: npi && npi.length === 10 ? null : firstName,
            lastName: npi && npi.length === 10 ? null : lastName
        });
        setIsSyncMode(true);
        setShowAddPhysician(true);
    }

    const SyncPhysician = (id) => {
        Api.postRequest(Api.URI_SyncPhysician + "?physicianID=" + id).then((res) => {
            if (res.data.statusCode == 200) {
                if (res.data.result != null) {
                    Common.showSuccessAlertAutoClose("Physician synced successfully", "success", "Success!", 3000);
                    GetPhysicianList();
                } 
                else {
                    Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
                }
            }
            else {
                Common.showSuccessAlert(res.data.message, "warning", "Failed!", 3000);
            }
        }).catch((ex) => {
            Common.showSuccessAlertAutoClose("some error occured while processing your request", "warning", "Failed!", 3000);
        });
    }

    const SelectAllPhysicians = () => {
        setSelectedPhysicians([...physicianListData]);
    }

    const HandleSelectAllToggle = (e) => {
        if (e.target.checked) {
            // Select all loaded physicians
            setSelectedPhysicians([...physicianListData]);
        } else {
            // Deselect all
            setSelectedPhysicians([]);
        }
    }

    const IsAllSelected = () => {
        if (physicianListData.length === 0) return false;
        return physicianListData.every(physician => selectedPhysicians.some(p => p.physicianId === physician.physicianId));
    }

    const SelectVisiblePhysicians = () => {
        // Get all visible rows from the table
        const table = document.getElementById("physicianList");
        if (!table) return;
        
        const visibleIds = [];
        const rows = table.querySelectorAll('tbody tr');
        rows.forEach((row) => {
            const checkbox = row.querySelector('input[type="checkbox"]');
            if (checkbox) {
                visibleIds.push(parseInt(checkbox.value));
            }
        });
        
        // Find the full physician objects for the visible IDs
        const visiblePhysicians = physicianListData.filter(physician => 
            visibleIds.includes(physician.physicianId)
        );
        
        setSelectedPhysicians(visiblePhysicians);
    }

    const SyncSelectedPhysicians = () => {
        // Determine which physicians to sync:
        // - If no selection OR all selected → sync all physicians
        // - If some selected → sync only selected physicians
        const isAllSelected = selectedPhysicians.length === physicianListData.length && physicianListData.length > 0;
        const physiciansToSync = (selectedPhysicians.length === 0 || isAllSelected) 
            ? physicianListData 
            : selectedPhysicians;

        if (physiciansToSync.length === 0) {
            Common.showSuccessAlert("No physicians available to sync", "warning", "No Physicians!", 3000);
            return;
        }

        // Filter physicians that have NPI (10 digits)
        const physiciansWithNpi = physiciansToSync.filter(p => {
            const npi = Common.replaceNullWithString(p.npi);
            return npi && npi.length === 10;
        });

        if (physiciansWithNpi.length === 0) {
            Common.showSuccessAlert("None of the physicians have a valid NPI. Please ensure physicians have NPI to sync.", "warning", "No Valid NPI!", 3000);
            return;
        }

        // Extract physician IDs as integers (nullable int array)
        const physicianIds = physiciansWithNpi.map(p => p.physicianId);

        // If some physicians were filtered out, show a message
        if (physiciansWithNpi.length < physiciansToSync.length) {
            const skippedCount = physiciansToSync.length - physiciansWithNpi.length;
            Common.showSuccessAlert(
                `${skippedCount} physician(s) without NPI will be skipped. Syncing ${physiciansWithNpi.length} physician(s) with NPI.`,
                "info",
                "Sync Notice",
                4000
            );
        }

        // Send POST request with List<int?> in the body
        Api.postRequest(Api.URI_EnrichAndSyncPhysicians, physicianIds).then((res) => {
            if (res.data.statusCode == 200 || res.data.success) {
                // Check if result contains unprocessed physicians list
                const unprocessedPhysicians = res.data.result;
                
                if (unprocessedPhysicians && Array.isArray(unprocessedPhysicians) && unprocessedPhysicians.length > 0) {
                    // Show list of unprocessed physicians
                    const unprocessedList = unprocessedPhysicians.join(", ");
                    Common.showSuccessAlert(
                        `The following physicians could not be processed: ${unprocessedList}`,
                        "warning",
                        "Partial Success",
                        5000
                    );
                } else {
                    // All physicians processed successfully
                    Common.showSuccessAlertAutoClose("All selected physicians have been processed successfully", "success", "Success!", 3000);
                }
                
                setSelectedPhysicians([]);
                GetPhysicianList();
            }
            else {
                Common.showSuccessAlert(res.data.message || "Failed to sync physicians", "warning", "Failed!", 3000);
            }
        }).catch((ex) => {
            // Handle exceptions separately
            console.error("Error syncing physicians:", ex);
            const errorMessage = ex?.response?.data?.message || ex?.message || "An error occurred while processing your request";
            Common.showSuccessAlert(errorMessage, "error", "Error", 5000);
        });
    }

    //#endregion

    //#region Set as Duplicate

    const HandleSetAsDuplicate = (physicianObj) => {
        setDuplicatePhysician(physicianObj);
        setSelectedReplacementPhysician(null);
        setShowDuplicateModal(true);
    }

    const HandleCloseDuplicateModal = () => {
        setShowDuplicateModal(false);
        setDuplicatePhysician(null);
        setSelectedReplacementPhysician(null);
        setReplacementFilter('');
    }

    const HandleConfirmDuplicate = () => {
        if (!selectedReplacementPhysician) {
            Common.showSuccessAlert("Please select a replacement physician", "warning", "No Selection!", 3000);
            return;
        }

        const confirmMessage = `Are you sure you want to replace the data of "${Common.replaceNullWithString(duplicatePhysician.lastName) + " " + Common.replaceNullWithString(duplicatePhysician.firstName)}" with "${Common.replaceNullWithString(selectedReplacementPhysician.lastName) + " " + Common.replaceNullWithString(selectedReplacementPhysician.firstName)}"? This will replace all data of the current physician with the selected physician's data (keeping the same Physician ID).`;
        
        Common.showConfirmation(
            confirmMessage, 
            "Replace Physician Data", 
            () => {
                const physicianID = duplicatePhysician.physicianId;
                const newPhysicianID = selectedReplacementPhysician.physicianId;
                Api.getRequest(Api.URI_ReplacePhysician + "/" + physicianID + "/" + newPhysicianID).then((res) => {
                    if (res.data.statusCode == 200 || res.data.success) {
                        Common.showSuccessAlertAutoClose("Physician data replaced successfully", "success", "Success!", 3000);
                        HandleCloseDuplicateModal();
                        GetPhysicianList();
                    }
                    else {
                        Common.showSuccessAlert(res.data.message || "Failed to replace physician data", "warning", "Failed!", 3000);
                    }
                }).catch((ex) => {
                    Common.showSuccessAlertAutoClose("some error occured while processing your request", "warning", "Failed!", 3000);
                });
            }, 
            null, 
            null
        );
    }

    const GetReplacementPhysicians = () => {
        if (!duplicatePhysician) return [];
        let filtered = physicianListData.filter(p => p.physicianId !== duplicatePhysician.physicianId);
        
        // Apply filter if search text is provided
        if (replacementFilter && replacementFilter.trim() !== '') {
            const filterLower = replacementFilter.toLowerCase().trim();
            filtered = filtered.filter(physician => {
                const fullName = (Common.replaceNullWithString(physician.lastName) + " " + Common.replaceNullWithString(physician.firstName)).toLowerCase();
                const npi = Common.replaceNullWithString(physician.npi) || '';
                
                return fullName.includes(filterLower) || 
                       npi.toLowerCase().includes(filterLower);
            });
        }
        
        return filtered;
    }

    //#endregion

    const [ShowAdvancedSearch, showAdvanceSearchSectionState] = useState(ShowAdvancedSearch ? true : false);
    const showAdvanceSearchSection = () => {
        showAdvanceSearchSectionState(!ShowAdvancedSearch);
    };

    return (
        <>
            <Animated animationIn="fadeIn" animationInDuration={1000}>
            <Card className="example example-compact">
                <CardHeader title='Physician List' />
                <CardBody>
                <div className="alert border-primary bg-transparent text-primary fade show" role="alert">
                    <div className="d-flex align-items-center">
                        <div className="alert-icon">
                            {/* <i className="fas fa-info-circle mr-4 text-primary"></i> */}
                        </div>
                        <div className="flex-1">
                            {/* <span className="h5 m-0 fw-700">Use buttons to do more actions </span> */}
                        </div>
                        {!isLoading && (
                            <>
                                <Button variant="primary" className="mr-5" size="sm" onClick={handleShowAddPhysician}>Add New Physician</Button>
                                {/* <Button variant="primary" className="mr-5" size="sm" onClick={handleShowAddBrightreePhysician}>Add Brightree Physician</Button> */}
                                <Button variant="success" size="sm" onClick={SyncSelectedPhysicians} className="mr-5">Sync Physician(s)</Button>
                            </>
                        )}
                    </div>
                </div>
                <table className="table table-striped table-hover table-sm table-bordered" id="physicianList">
                    <thead>
                        <tr>
                            <th width="50px">
                                <input 
                                    type="checkbox" 
                                    checked={IsAllSelected()}
                                    onChange={HandleSelectAllToggle}
                                />
                            </th>
                            <th 
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                onClick={() => handleSort('name')}
                            >
                                Name
                                {sortConfig.key === 'name' && (
                                    <span style={{ marginLeft: '5px' }}>
                                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                    </span>
                                )}
                            </th>
                            <th>Pro Designations</th>
                            <th>Telephone #</th>
                            <th>Email</th>
                            <th 
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                                onClick={() => handleSort('npi')}
                            >
                                NPI #
                                {sortConfig.key === 'npi' && (
                                    <span style={{ marginLeft: '5px' }}>
                                        {sortConfig.direction === 'asc' ? '↑' : '↓'}
                                    </span>
                                )}
                            </th>
                            <th width="100px" align="center">Active</th>
                            <th width="130px">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {physicianListUI}
                    </tbody>
                </table>
                </CardBody>
            </Card>
                

            </Animated>

            {/* Add New Physician Modal */}
            <AddEditPhysician
                open={showModalAddPhysician}
                toggleModal={handleCloseAdd}
                onSaveAPI={handleSavePhysician}
                userID={user.userID}
                facilityId={null}
                npi={syncPhysicianData.npi}
                firstName={syncPhysicianData.firstName}
                lastName={syncPhysicianData.lastName}
                modalTitle={isSyncMode ? "Sync Physician" : "Add New Physician"}
            />

            {/* Edit Physician Modal */}
            <Modal
                show={showEditModal}
                onHide={handleCloseEditModal}
                size="xl"
                centered
                scrollable
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Physician</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editingPhysician && (
                        <AddPhysicianmodal
                            key={editingPhysician.physicianId || 'edit-physician'}
                            physician={editingPhysician}
                            close={handleCloseEditModal}
                        />
                    )}
                </Modal.Body>
            </Modal>

            {/* Duplicate Physician Modal */}
            <Modal
                show={showDuplicateModal}
                onHide={HandleCloseDuplicateModal}
                size="lg"
                centered
                scrollable
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Set as Duplicate - Select Replacement Physician</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {duplicatePhysician && (
                        <div className="mb-3">
                            <h6>Current Physician (all references will be replaced):</h6>
                            <p className="mb-0">
                                <strong>Name:</strong> {Common.replaceNullWithString(duplicatePhysician.lastName) + " " + Common.replaceNullWithString(duplicatePhysician.firstName)}<br />
                                <strong>NPI:</strong> {Common.replaceNullWithString(duplicatePhysician.npi) || 'N/A'}
                            </p>
                            <p className="text-warning mt-2 mb-0">
                                <small><strong>Note:</strong> All records referencing this physician will be updated to reference the replacement physician instead.</small>
                            </p>
                        </div>
                    )}
                    <div className="mb-3">
                        <h6>Select Replacement Physician:</h6>
                        <div className="mb-2">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Filter by Name or NPI..."
                                value={replacementFilter}
                                onChange={(e) => setReplacementFilter(e.target.value)}
                            />
                        </div>
                        {GetReplacementPhysicians().length === 0 && replacementFilter && (
                            <div className="alert alert-info mb-2" role="alert">
                                No physicians found matching your filter.
                            </div>
                        )}
                        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                            <table className="table table-sm table-bordered">
                                <thead>
                                    <tr>
                                        <th width="50px">Select</th>
                                        <th>Name</th>
                                        <th>Pro Designations</th>
                                        <th>NPI</th>
                                        <th>Email</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {GetReplacementPhysicians().map((physician) => (
                                        <tr key={physician.physicianId}>
                                            <td>
                                                <input
                                                    type="radio"
                                                    name="replacementPhysician"
                                                    value={physician.physicianId}
                                                    checked={selectedReplacementPhysician?.physicianId === physician.physicianId}
                                                    onChange={() => setSelectedReplacementPhysician(physician)}
                                                />
                                            </td>
                                            <td>{Common.replaceNullWithString(physician.lastName) + " " + Common.replaceNullWithString(physician.firstName)}</td>
                                            <td>{Common.replaceNullWithString(physician.title) ? physician.title : "N/A"}</td>
                                            <td>{Common.replaceNullWithString(physician.npi) || 'N/A'}</td>
                                            <td>{Common.replaceNullWithString(physician.address?.email) || 'N/A'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={HandleCloseDuplicateModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" size="sm" onClick={HandleConfirmDuplicate}>
                        Confirm Duplicate
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );

}

export default PhysicianList;

/*eslint-disable */


